import { useMemo } from 'react';

import usePagination from '@/hooks/usePagination';
import { FilePurposeEnum } from '@/types/schema';

import { FileMinifiedFragment } from '../../graphql/fragments/generated/fileMinified';
import { FilesQueryVariables, useFilesQuery } from '../../graphql/queries/generated/files';

const purpose = FilePurposeEnum.TaskCategory;

export default function useFiles({
  sort,
  filters,
  first,
  pause,
}: {
  filters?: FilesQueryVariables['filters'];
  sort?: FilesQueryVariables['sort'];
  first?: number;
  pause?: boolean;
}) {
  const {
    data: files,
    isFetching,
    isLoading,
    error,
    fetchMore,
    isFetchingMore,
    result: { data },
    totalCount,
  } = usePagination(
    useFilesQuery,
    {
      filters: { purpose: [purpose], ...filters },
      sort,
    },
    {
      edgeKey: 'files',
      pageSize: first,
      pause,
    },
  );

  const systemGeneratedFiles = useMemo(
    () =>
      (data?.systemGeneratedFiles?.edges
        ?.filter(({ node }) => node.filterQuery)
        ?.map(({ node }) => node) ?? []) as FileMinifiedFragment[],
    [data?.systemGeneratedFiles?.edges],
  );

  return {
    systemGeneratedFiles,
    files,
    isLoading,
    fetching: isFetching || isLoading,
    error,
    fetchMore,
    isFetchingMore,
    totalCount,
  };
}

export type UseFilesReturnType = ReturnType<typeof useFiles>;
